import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { CanAccommodateOccupancy } from 'app/helpers';
import { CustomTranslatePipe } from 'app/widget/index.pipes';
import { DatesAndAccupancy, HotelBookingDataDetails } from 'app/widget/state/index.types';

@Component({
  selector: 'app-occupancy-info',
  standalone: true,
  imports: [...TAIGA_UI_MODULES, CustomTranslatePipe, TranslateModule],
  templateUrl: './occupancyInfo.component.html',
  styleUrl: './occupancyInfo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccupancyInfoComponent {

  datesAndAccupancy = input.required<DatesAndAccupancy>()
  bestPrice = input.required<HotelBookingDataDetails>()

  CanAccommodateOccupancy = CanAccommodateOccupancy

}
